import { useEffect } from 'react';
import { useIntercom } from 'react-use-intercom';

export const useIntercomHideOnOpen = (open: boolean) => {
  const { update, hide, isOpen } = useIntercom();

  useEffect(() => {
    if (open) {
      update({ hideDefaultLauncher: true });
      if (isOpen) {
        hide();
      }
    }
    return () => {
      update({ hideDefaultLauncher: false });
    };
  }, [open, update, hide, isOpen]);
};
